export const appRoutes = {
    public: {
        home: () => {
            return '/';
        },
        tenantNotFound: () => {
            return '/public/tenant/not-found';
        },
        userInvitation: () => {
            return '/public/user-invitation/:token';
        },
    },
    auth: {
        emailVerification: () => {
            return '/auth/email-verification/:token';
        },
        setPassword: () => {
            return '/auth/set-password/:token';
        },

        loginIn: () => {
            return '/auth/login';
        },
    },
    marketPalceRoutes: {
        marketPlace: (tenantId?: string) => {
            return `/${tenantId ?? ':tenantId'}/market-place`;
        },
        addNewMarketPlace: (tenantId?: string, marketPlaceId?: string) => {
            return `/${tenantId ?? ':tenantId'}/market-place/add/${marketPlaceId ? `${marketPlaceId}` : ':marketPlaceId'}`;
        },
    },
    myWork: {
        myWork: (tenantId?: string) => {
            return `/${tenantId ?? ':tenantId'}/my-work`;
        },
        myWorkWithTicket: (ticketNo?: string, tenantId?: string) => {
            return `/${tenantId ?? ':tenantId'}/my-work/${ticketNo ? ticketNo : ':ticketNo'}`;
        },
    },

    workspace: {
        fetchData: () => {
            return '/workspace/fetch-data';
        },
        boardListing: (tenantId?: string, workspaceSlug?: string, boardSlug?: string) => {
            return `/${tenantId ?? ':tenantId'}/${workspaceSlug ? workspaceSlug : ':workspaceId'}/${boardSlug ? boardSlug : ':boardId'}`;
        },
        boadListingWithTicket: (tenantId?: string, workspaceSlug?: string, boardSlug?: string, ticketNo?: string) => {
            return `/${tenantId ?? ':tenantId'}/${workspaceSlug ? workspaceSlug : ':workspaceId'}/${boardSlug ? boardSlug : ':boardId'}/${ticketNo ? ticketNo : ':ticketNo'}`;
        },
    },
};
